import {h, render, Component} from 'preact';
import FormV2 from "./FormV2";
import Form from "./Form";
import request from "../utils/Request";
import {SHOP} from "../constants/Common";
import {observer} from 'mobx-preact';
import appStore from "../stores/AppStore";
import campaignStore from "../stores/CampaignStore";
import Trigger from "./Trigger";
import formStore from "../stores/FormStore";
import WinPage from "./WinPage";
import winPageStore from "../stores/WinPageStore";
import Layout from "./Layout";
import {getCookie} from "../utils/Cookie";
import ScarCityBar from "./ScarCityBar";


@observer
class App extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        request.get(`get_campaign/?shopify_store=${SHOP}`).then(response => {
            if(!Object.keys(response.data).length){
                return;
            };
            campaignStore.getCampaignFromJson(response.data);
            appStore.campaignLoaded = true;
            if (campaignStore.autoOpenForNewVisitors && (!getCookie('_kol_saw_pop_up') || SHOP === 'sunber.myshopify.com')){
                appStore.showTrigger = false;
                setTimeout(() => {
                    appStore.showPopup = true;
                    appStore.showTrigger = true;
                }, campaignStore.autoOpenDelaySeconds * 1000)
            }
        }).catch(e => console.log(e.response));
    }

    getCampaignForm() {
        if (campaignStore.formTheme === 'v1') {
            return <Form formStore={formStore}
                         campaignStore={campaignStore}
                         appStore={appStore}
                         winPageStore={winPageStore}
            />

        } else {
            return <FormV2 formStore={formStore}
                           campaignStore={campaignStore}
                           appStore={appStore}
                           winPageStore={winPageStore}
            />
        }
    }

    render() {
        if (appStore.appIsVisible && appStore.campaignLoaded) {
            if (appStore.showPopup) {
                const formComponent = this.getCampaignForm()
                return<Layout> {formComponent}</Layout>
            }
            else if (appStore.showWinPage){
                return <Layout><WinPage
                    winPageStore={winPageStore}
                    campaignStore={campaignStore}
                    appStore={appStore}
                />
                </Layout>
            }
            else if(appStore.showTrigger){
                return <Trigger campaignStore={campaignStore} appStore={appStore}/>
            }
        }
        if(appStore.campaignLoaded && campaignStore.scarCityBarIsActive && getCookie('kol_wheel_app_show_scarcity')){
            return <ScarCityBar
                campaignStore={campaignStore}
                winPageStore={winPageStore}
            />
        }
        return null;
    }
}

export default App;
